import { useState } from "react";
import Grid from "@mui/material/Grid";
import Fab from "@mui/material/Fab";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Footer = () => {
  const [visibleArrowUpward, setVisibleArrowUpward] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisibleArrowUpward(true);
    } else if (scrolled <= 300) {
      setVisibleArrowUpward(false);
    }
  };

  const actionScrollToElement = (e: any) => {
    e.preventDefault(); // Stop Page Reloading
    e.stopPropagation();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <div className="app-footer-wrapper" id="contact-us">
      <div className="app-footer__content">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          className="app-footer__gridContainer"
        >
          <Grid item xs={12} className="app-footer__grid">
            <h2 className="app-footer__headText">Contact us</h2>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            className="app-footer__grid app-footer__grid-addressContainer "
          >
            <address>
              <span className="app-footer__grid-address">
                <span className="app-footer__grid-locIcon">
                  <LocationOnIcon />
                </span>
                <span className="app-footer__grid-locText">
                  13- B, NA Athipalayam Road, Chinnavedampatti (PO),
                  <br className="app-footer__grid-locTextBR" />{" "}
                  Chinnavedampatti,
                  <br className="app-footer__grid-locTextBR" /> Ganapathy,
                  Coimbatore-641049,
                  <br /> Tamil Nadu, India.
                </span>
              </span>
              <span className="app-footer__grid-phone">
                <span className="app-footer__grid-phoneIcon">
                  <LocalPhoneIcon />
                </span>
                <span className="app-footer__grid-phoneText">
                  <a
                    href="https://wa.me/919790065539?text=Hello%2C%20I%20would%20like%20to%20enquire%20about%20your%20products%20and%20services.%20Kindly%20share%20more%20details"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="app-footer__grid-whatsappLink"
                  >
                    <WhatsAppIcon className="app-footer__grid-whatsappIcon" />
                    <span>WhatsApp: +91 9790065539</span>
                  </a>
                  <span className="app-footer__grid-phoneSeparator"> | </span>
                  <span>Phone: +91 8667280908</span>
                </span>
              </span>
              <span className="app-footer__grid-email">
                <span className="app-footer__grid-emailIcon">
                  <EmailIcon />
                </span>
                jeevaindustries8@gmail.com
              </span>
            </address>
          </Grid>
          <Grid item xs={12} md={7} className="app-footer__grid">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.732315574282!2d76.9794153504845!3d11.058684892091716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859bcdb4ba0b7%3A0x661ab695ef89dbed!2sJeeva%20Industries%2C%2070%2F1A%2C%20Athipalayam%20Road%2C%20Chinnavedampatti%2C%20Coimbatore!5e0!3m2!1sen!2sin!4v1661240857303!5m2!1sen!2sin"
              width="100%"
              height="100%"
              title="Jeeva Industries location map"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy={"no-referrer-when-downgrade"}
            ></iframe>
          </Grid>
        </Grid>
        <div className="app-footer-copyrights">
          <p className="app-footer-copyrights-para ">
            © {new Date().getFullYear()} Jeeva Industries all rights Reserved.
          </p>
        </div>
      </div>
      <div>
        <Fab
          color="primary"
          className="footer-fab-whatsappIcon"
          aria-label="WhatsApp chat"
          size="medium"
          onClick={() => {
            window.open(
              "https://wa.me/919790065539?text=Hello%2C%20I%20would%20like%20to%20enquire%20about%20your%20products%20and%20services.%20Kindly%20share%20more%20details",
              "_blank",
            );
          }}
        >
          <WhatsAppIcon />
        </Fab>
        {visibleArrowUpward && (
          <Fab
            color="primary"
            className="footer-fab-topIcon"
            aria-label="ArrowUpwardIcon"
            size="medium"
            onClick={(e) => {
              actionScrollToElement(e);
            }}
          >
            <ArrowUpwardIcon />
          </Fab>
        )}
      </div>
    </div>
  );
};

export default Footer;
